"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateOtpDtoPurposeEnum = void 0;
exports.instanceOfGenerateOtpDto = instanceOfGenerateOtpDto;
exports.GenerateOtpDtoFromJSON = GenerateOtpDtoFromJSON;
exports.GenerateOtpDtoFromJSONTyped = GenerateOtpDtoFromJSONTyped;
exports.GenerateOtpDtoToJSON = GenerateOtpDtoToJSON;
exports.GenerateOtpDtoToJSONTyped = GenerateOtpDtoToJSONTyped;
/**
 * @export
 */
exports.GenerateOtpDtoPurposeEnum = {
    Login: 'login'
};
/**
 * Check if a given object implements the GenerateOtpDto interface.
 */
function instanceOfGenerateOtpDto(value) {
    return true;
}
function GenerateOtpDtoFromJSON(json) {
    return GenerateOtpDtoFromJSONTyped(json, false);
}
function GenerateOtpDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'boundPhone': json['boundPhone'] == null ? undefined : json['boundPhone'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
    };
}
function GenerateOtpDtoToJSON(json) {
    return GenerateOtpDtoToJSONTyped(json, false);
}
function GenerateOtpDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phone': value['phone'],
        'email': value['email'],
        'boundPhone': value['boundPhone'],
        'purpose': value['purpose'],
    };
}
